import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as React from 'react';
import { Form, useFormikContext } from 'formik';
import { customComponentsContextObj, StepControlsContextProvider } from '../../utils';
import { EFormStatus } from '../../constants';
import { QuestionActionsContainer } from '../QuestionActionsContainer';
import { jsx as _jsx } from "react/jsx-runtime";
export var FormContainer = function FormContainer(props) {
  var formikContext = useFormikContext();
  var setStatus = formikContext.setStatus,
    handleSubmit = formikContext.handleSubmit,
    validateForm = formikContext.validateForm,
    values = formikContext.values;
  var _setPrevStep = props.setPrevStep,
    question = props.question,
    fieldMapper = props.fieldMapper,
    stepControls = props.stepControls;
  var stepCtx = _objectSpread(_objectSpread({}, stepControls), {}, {
    setPrevStep: function setPrevStep() {
      return _setPrevStep(formikContext);
    }
  });
  var _ref = React.useContext(customComponentsContextObj),
    FormHeaderComponent = _ref.FormHeaderComponent,
    ReturnButtonComponent = _ref.ReturnButtonComponent,
    ProgressBarComponent = _ref.ProgressBarComponent,
    WidgetLayoutComponent = _ref.WidgetLayoutComponent,
    QuestionLayoutComponent = _ref.QuestionLayoutComponent;
  React.useEffect(function () {
    validateForm(values);
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [question.code]);
  return /*#__PURE__*/_jsx(StepControlsContextProvider, {
    value: stepCtx,
    children: /*#__PURE__*/_jsx(WidgetLayoutComponent, {
      header: /*#__PURE__*/_jsx(FormHeaderComponent, {
        returnButton: /*#__PURE__*/_jsx(ReturnButtonComponent, {
          onPrevStep: stepCtx.setPrevStep,
          isFirstStep: stepCtx.isFirstStep
        })
      }),
      progressBar: /*#__PURE__*/_jsx(ProgressBarComponent, {
        maxStepsCount: stepCtx.maxStepsCount,
        currentStepCount: stepCtx.currentStepCount
      }),
      children: /*#__PURE__*/_jsx(Form, {
        onChange: function onChange() {
          stepCtx.resetError();
          setStatus(EFormStatus.QuestionEdited);
        },
        onSubmit: function onSubmit(event) {
          setStatus(EFormStatus.QuestionSubmitted);
          return handleSubmit(event);
        },
        children: /*#__PURE__*/_jsx(QuestionLayoutComponent, {
          question: question,
          error: stepCtx.stepError,
          actions: /*#__PURE__*/_jsx(QuestionActionsContainer, {
            question: question
          }),
          fieldMapper: fieldMapper,
          navigationDirection: stepCtx.lastNavDirection
        })
      })
    })
  });
};
FormContainer.displayName = 'FormContainer';